import { render } from "./HeroiconsOutlineArrowCircleLeft.vue?vue&type=template&id=2597fc28"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowCircleLeft.vue"]])

export default __exports__